module.exports = __webpack_public_path__ + "static/media/comingout.f56c61d1.jpg";